// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const OutOfStock: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13">
            <path
                fill="currentColor"
                d="M6,0 C2.68593764,0 0,2.68593764 0,6 C0,9.31406236 2.68593764,12 6,12 C9.31406236,12 12,9.31406236 12,6 C12,2.68593764 9.31406236,0 6,0 Z M8.49140596,8.07421875 C8.69207811,8.31117153 8.66242933,8.66648412 8.42512465,8.86710978 C8.3203125,8.95546889 8.19140625,9 8.0625,9 C7.90284348,9 7.74398446,8.93224239 7.63265634,8.80078125 L6,6.87187529 L4.36640632,8.80078125 C4.25625014,8.93203139 4.09687507,9 3.91640639,9 C3.80859375,9 3.6796875,8.95546889 3.57421875,8.86640596 C3.33703136,8.66573381 3.30726564,8.31046844 3.50793743,8.07351494 L5.26406264,6 L3.50859368,3.92578125 C3.30703139,3.68906236 3.33749986,3.33281279 3.57421875,3.13359404 C3.81093764,2.93203139 4.16718757,2.96249986 4.36640632,3.19921875 L6,5.12812507 L7.63289022,3.19828176 C7.83321047,2.96109366 8.18882775,2.93085909 8.42578125,3.13200045 C8.66296864,3.33267188 8.69273472,3.68793726 8.49206257,3.92489076 L6.73593736,6 L8.49140596,8.07421875 Z"
                transform="translate(0 .5)"
            />
        </svg>
    );
};

export default React.memo(OutOfStock);
